import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout from "@/components/AuthLayout";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Mot de passe oublié" subtitle="Nous vous enverrons un lien de réinitialisation">
      {sent ? (
        <div className="text-[#C4C1B8] space-y-4" data-testid="forgot-confirmation">
          <p>Si cet email est enregistré, un lien de réinitialisation vient d'être envoyé. Vérifiez votre boîte de réception.</p>
          <Link to="/connexion" className="text-[#C9A24B] hover:underline inline-block">← Retour à la connexion</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label className="text-white mb-2 block">Email</Label>
            <Input
              type="email"
              data-testid="forgot-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="bg-[#181820] border-white/10 text-white"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="forgot-submit-btn"
            className="w-full gold-bg text-black font-semibold rounded-full py-6 hover:opacity-90"
          >
            {loading ? "Envoi..." : "Envoyer le lien"}
          </Button>
          <Link to="/connexion" className="text-sm text-[#C9A24B] hover:underline block text-center">
            Retour à la connexion
          </Link>
        </form>
      )}
    </AuthLayout>
  );
}
